export const analysisColors = {
  small: ["#FECA55", "#F6A06D", "#E27D86", "#AC557A"],
  middle: [
    "#F9E851",
    "#FECA55",
    "#F6A06D",
    "#E27D86",
    "#AC557A",
    "#8D4C7D",
    "#6B406E",
    "#40324F",
  ],
  large: [
    "#FFF2B1",
    "#FFED65",
    "#FDD751",
    "#FEC557",
    "#F6A06D",
    "#EC8B7C",
    "#E47E85",
    "#BD667D",
    "#AC557A",
    "#8D4C7D",
    "#6B406E",
    "#40324F",
  ],
};

export const marketingColors = {
  small: ["#FFF2B1", "#F36DA5", "#A95699", "#653F8E"],
  middle: [
    "#FFF2B1",
    "#FED0A0",
    "#FA9BB8",
    "#F36DA5",
    "#C55F94",
    "#9C519A",
    "#744196",
    "#FDEAB9",
  ],
  large: [
    "#FFF2B1",
    "#FDEAB9",
    "#FED7A6",
    "#FEC395",
    "#F6A5C1",
    "#F381A8",
    "#F06695",
    "#ED4B82",
    "#E04980",
    "#CD6191",
    "#BC5C96",
    "#A95699",
    "#99519B",
    "#88499A",
    "#784397",
    "#653F8E",
    "#54417B",
    "#FDEAB9",
  ],
};

export const customerColors = {
  small: ["#6E735B", "#C2A170", "#536E8D", "#809FB9"],
  middle: [
    "#809FB9",
    "#536E8D",
    "#C2A170",
    "#6E735B",
    "#DAB986",
    "#3C6569",
    "#C6A743",
    "#A3A28A",
    "#657960",
    "#9F895E",
  ],
  gradient: [
    ["rgba(128, 159, 185, 0.2)", "#809FB9"],
    ["rgba(83, 110, 141, 0.2)", "#536E8D"],
    ["rgba(194, 161, 112, 0.2)", "#C2A170"],
    ["rgba(110, 115, 91, 0.2)", "#6E735B"],
    ["rgba(218, 185, 134, 0.2)", "#DAB986"],
    ["rgba(60, 101, 105, 0.2)", "#3C6569"],
    ["rgba(198, 167, 67, 0.2)", "#C6A743"],
    ["rgba(163, 162, 138, 0.2)", "#A3A28A"],
    ["rgba(101, 121, 96, 0.2)", "#657960"],
    ["rgba(159, 137, 94, 0.2)", "#9F895E"],
  ],
};

export const serviceColors = {
  small: ["#91D0CE", "#56B9D2", "#3F97C2", "#2D5E9E"],
  middle: [
    "#DCECC9",
    "#91D0CE",
    "#56B9D2",
    "#3F97C2",
    "#3371AA",
    "#274B93",
    "#1B277C",
    "#131A55",
  ],
  large: [
    "#DCECC9",
    "#B3DDCC",
    "#8ACDCE",
    "#62BED2",
    "#46AACE",
    "#3D91BE",
    "#3577AE",
    "#2D5E9E",
    "#24448E",
    "#1C2B7F",
    "#162065",
    "#11174B",
  ],
};

export const kolColors = {
  small: ["#3571E9", "#7BBAFD", "#2BCDBE", "#9F69E3"],
  middle: [
    "#3571E9",
    "#7BBAFD",
    "#2BCDBE",
    "#9F69E3",
    "#CDBEFF",
    "#CDE0FE",
    "#6A84B7",
    "#7464D1",
  ],
  large: [
    "#3571E9",
    "#7BBAFD",
    "#2BCDBE",
    "#9F69E3",
    "#CDBEFF",
    "#CDE0FE",
    "#6A84B7",
    "#7464D1",
    "#E3E3E3",
    "#FFD988",
    "#F8AC60",
    "#88AED5",
  ],
};
